import React from 'react';
import theme from 'config/theme';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  UrgentPriorityIcon,
  HighPriorityIcon,
  MediumPriorityIcon,
  LowPriorityIcon,
} from '@components';

export const PRIORITY_ICONS = {
  0: <MoreHorizIcon fontSize="small" />,
  1: <UrgentPriorityIcon />,
  2: <HighPriorityIcon />,
  3: <MediumPriorityIcon />,
  4: <LowPriorityIcon />,
};

export const GENERIC_TICKETS_FIELD_NAMES = {
  assignee: 'Assignee',
  status: 'Status',
  stage: 'Stage',
  team: 'Team',
  due_date: 'Due Date',
  priority: 'Priority',
  reason: 'Ticket Reason',
};

export const GENERIC_TICKETS_STATUS = {
  0: {
    label: 'Backlog',
    value: 0,
    styles: {
      backgroundColor: theme.palette.grays.gray200,
      color: theme.palette.grays.gray900,
    },
  },
  2: {
    label: 'In Progress',
    value: 2,
    styles: {
      backgroundColor: theme.palette.yellows.yellow200,
      color: theme.palette.yellows.yellow900,
    },
  },
  3: {
    label: 'Done',
    value: 3,
    styles: {
      backgroundColor: theme.palette.greens.green200,
      color: theme.palette.greens.green900,
    },
  },
  12: {
    label: 'Cancelled',
    value: 12,
    styles: {
      backgroundColor: theme.palette.oranges.orange200,
      color: theme.palette.oranges.orange900,
    },
  },
};

export const GENERIC_TICKETS_STATUS_NAMES = {
  0: 'Backlog',
  2: 'In Progress',
  3: 'Done',
  12: 'Cancelled',
};

export const GENERIC_TICKETS_STATUS_OPTIONS = Object.keys(
  GENERIC_TICKETS_STATUS
).map((key) => ({
  text: GENERIC_TICKETS_STATUS[key].label,
  value: Number(key),
}));

export const GENERIC_TICKET_PRIORITY_OPTIONS = [
  { text: 'No priority', value: 0 },
  { text: 'Urgent', value: 1 },
  { text: 'High', value: 2 },
  { text: 'Medium', value: 3 },
  { text: 'Low', value: 4 },
];

export const GENERIC_TICKET_REASON_OPTIONS = [
  { text: 'Pre-delivery request', value: 'Pre-delivery request' },
  { text: 'Customer communication', value: 'Customer communication' },
  { text: 'Swap request', value: 'Swap request' },
  {
    text: 'Vehicle replacement before delivery',
    value: 'Vehicle replacement before delivery',
  },
  { text: 'Renewal', value: 'Renewal' },
  {
    text: 'Vehicle return / Cancellation',
    value: 'Vehicle return / Cancellation',
  },
  { text: 'Refund', value: 'Refund' },
  { text: 'Leasing / Offer info', value: 'Leasing / Offer info' },
  { text: 'Lease terms dispute', value: 'Lease terms dispute' },
  { text: 'New Lead', value: 'New Lead' },
  {
    text: 'Update vehicle delivery process / Date',
    value: 'Update vehicle delivery process / Date',
  },
  { text: 'Buyout price', value: 'Buyout price' },
  {
    text: 'Extra KM or driver / Insurance add-ons / Green Card',
    value: 'Extra KM or driver / Insurance add-ons / Green Card',
  },
  { text: 'Service update / ERFUDD', value: 'Service update / ERFUDD' },
  { text: 'Retail price certificate', value: 'Retail price certificate' },
  { text: 'Open balance info / Refund', value: 'Open balance info / Refund' },
  { text: 'Billing details', value: 'Billing details' },
  { text: 'Car sales', value: 'Car sales' },
  { text: 'Customer complaint', value: 'Customer complaint' },
  { text: 'Contract creation', value: 'Contract creation' },
  { text: 'Account deletion', value: 'Account deletion' },
  { text: 'Extra documents', value: 'Extra documents' },
  { text: 'Other', value: 'Other' },
];
